import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';
import type {
  TagRequestParams,
  FolderRequestParams,
  AssignmentRequestParams,
  SecurityGroupRequestParams,
  SavedSearchResponse,
  CategorizationViewResultsProps,
  CategorizationProjectNotificationStatus,
  CategorizationProviewParams,
  CategorizationGoToDocListParams,
} from '../types/categorization.type.ts';
const BASE_URL_PROVIEW = `${BASE_URL}/productions/api/v1/proview`;
const BASE_URL_Tag_FolderTree = `${BASE_URL}/tagsfoldering/api/v1/tagsandfolders/tree`;
const BASE_URL_SearchTree = `${BASE_URL}/reporting/api/v1/review/document-audit`;
const BASE_URL_AssignmentTree = `${BASE_URL}/productions/api/v1/proview/tree`;

export const categorizationSecurityGroupView = async (
  payload: SecurityGroupRequestParams
): Promise<any> => {
  const response = await apiClient.post<any>(
    `${BASE_URL_PROVIEW}/view/proview`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
export const categorizationTagTreeView = async (
  payload: TagRequestParams
): Promise<any> => {
  const response = await apiClient.get<any>(`${BASE_URL_Tag_FolderTree}/tag`, {
    params: payload,
    headers: {
      accept: 'text/plain',
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const categorizationFolderTreeView = async (
  payload: FolderRequestParams
): Promise<any> => {
  const response = await apiClient.get<any>(
    `${BASE_URL_Tag_FolderTree}/folder`,
    {
      params: payload,
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const categorizationSearchTreeView = async (): Promise<any> => {
  const response = await apiClient.get<any>(
    `${BASE_URL_SearchTree}/search-list`,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const categorizationAssignmentTreeView = async (
  payload: AssignmentRequestParams
): Promise<any> => {
  const response = await apiClient.get<SavedSearchResponse>(
    `${BASE_URL_AssignmentTree}/assignment`,
    {
      params: payload,
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const categorizationRunProview = async (
  payload: CategorizationViewResultsProps
): Promise<any> => {
  const {data} = await apiClient.post<any>(`${BASE_URL_PROVIEW}/run`, payload);

  return data;
};

export const getProjectNotificationStatus = async (
  payload: CategorizationProjectNotificationStatus
): Promise<any> => {
  const {data} = await apiClient.get<any>(
    `${BASE_URL_PROVIEW}/notifications/status`,
    {
      params: payload,
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
};

export const postCategorizationProview = async (
  payload: CategorizationProviewParams
): Promise<any> => {
  const {data} = await apiClient.post<any>(
    `${BASE_URL_PROVIEW}/view/proview`,
    payload
  );
  return data;
};

export const getGoToDocList = async (
  payload: CategorizationGoToDocListParams
): Promise<any> => {
  const {data} = await apiClient.get<any>(`${BASE_URL_PROVIEW}/doclist`, {
    params: payload,
    headers: {
      accept: 'text/plain',
      'Content-Type': 'application/json',
    },
  });
  return data;
};
